import React, { startTransition, useState } from 'react';
import './App.css';
import Background, { Scene } from './Background';
import Start from './pages/Start';
import Abstract from './pages/Abstract';
import Plants from './pages/Plants';
import Display, { plants } from './Display';

export const BIBLIOGRAPHY_LINK = 'https://docs.google.com/document/d/1ShYo8wKtzmAfrEOSBy-8-Iusr7e_DJaW56I8DzLCK5M/edit?usp=sharing';

enum Page {
  Start,
  Abstract,
  Plants,

  Plant1,
  Plant2,
  Plant3,
}

const pageSceneMap = {
  [Page.Start]: Scene.Welcome,
  [Page.Abstract]: Scene.Welcome,
  [Page.Plants]: Scene.Plants,
  [Page.Plant1]: Scene.Plant1,
  [Page.Plant2]: Scene.Plant2,
  [Page.Plant3]: Scene.Plant3,
};



function App() {

  const [page, setPage] = useState(Page.Start);
  const navigate = (page: Page) => {
    return () => { setIndex(0); startTransition(() => setPage(page)) };
  }
  const bibLink = () => {
    window.open(BIBLIOGRAPHY_LINK, '_blank');
  }

  const [index, setIndex] = useState(0);

  const currentPlant = {
    [Page.Plant1]: plants[0],
    [Page.Plant2]: plants[1],
    [Page.Plant3]: plants[2],
    [Page.Plants]: undefined,
    [Page.Start]: undefined,
    [Page.Abstract]: undefined,
  }[page];
  return (
    <div className="App">
      <div className='backgroundCanvas'>
        <Background scene={pageSceneMap[page]} plant={currentPlant} index={index} />
      </div>
      <main>
        {
          ({
            [Page.Start]: ( <Start next={navigate(Page.Abstract)} /> ),
            [Page.Abstract]: ( <Abstract next={navigate(Page.Plants)} bibLink={bibLink} /> ),
            [Page.Plants]: ( <Plants next={[navigate(Page.Plant1), navigate(Page.Plant2), navigate(Page.Plant3)]} /> ),
            [Page.Plant1]: ( <Display plant={plants[0]} back={navigate(Page.Plants)} bibLink={bibLink} index={index} setIndex={setIndex} /> ),
            [Page.Plant2]: ( <Display plant={plants[1]} back={navigate(Page.Plants)} bibLink={bibLink} index={index} setIndex={setIndex} /> ),
            [Page.Plant3]: ( <Display plant={plants[2]} back={navigate(Page.Plants)} bibLink={bibLink} index={index} setIndex={setIndex} /> ),
          }[page])
        }
      </main>
    </div>
  );
}

export default App;
